<template>
    <MainContainer :container="!xs()" background="darkGrey" :footer="false" :style="{ 'padding-bottom': '80px' }">
            <slot></slot>
        <ActionBar :fixed="true" :style="{ 'height': '80px' }">
            <slot name="actionBar"></slot>
        </ActionBar>
    </MainContainer>
</template>

<script>
import MainContainer from '@/components/layout/MainContainer.vue';
import ActionBar from '@/components/global/ActionBar.vue';

export default {
    components: {
        MainContainer,
        ActionBar
    },
    methods: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
